<template>
  <div class="dashboard-wrapper" :class="{'sidebar-open': sideOpen}">
    <dashboard-sidebar></dashboard-sidebar>
    <transition name="fade">
      <sidebar-overlay v-if="sideOpen"></sidebar-overlay>
    </transition>
    <main>
      <dashboard-header></dashboard-header>
      <div class="dashboard-content">
        <div class="row mb-30">
          <div class="col-md-6">
            <h3 class="page-title">
              Ok,
              <span class="primary-color">{{ user.firstName }}</span> let's start doing business.
            </h3>
            <h6 class="mb-0">This is your dashboard, the place where you get a quick insight about your activity.</h6>
            <div class="row">
              <div class="col-lg-6 mt-30">
                <div class="dashboard-shortcut kp-flat-card small-shadow p-0">
                  <a href="#" class="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                      <path
                        d="M32 4C28.5 4 25.5 6 24 8.9 22.5 6 19.5 4 16 4H0v32.5L0.1 38h16c6.8 0 6.9 6.5 6.9 6.8l0.7-0.1L25 44.8C25 44.5 25.1 38 32 38H48V4H32zM46 36H32c-3.4 0-5.6 0.9-7 2.6V13h-2v25.6C21.6 36.9 19.5 36 16.1 36H2V6h14C19.9 6 23 9 23 13h2c0-4 3.1-7 7-7H46V36z"
                      />
                      <path d="M27.6 43.8l1.8 1C30.3 43 32.1 42 34.1 42H48v-2H34.1C31.3 40 28.8 41.3 27.6 43.8z" />
                      <path d="M14 40H0v2h14c2 0 3.8 0.9 4.6 2.7l1.8-0.7C19.2 41.5 16.7 40 14 40z" />
                    </svg>
                    <div>
                      <h5>Read the Basics</h5>
                      <p class="mb-0">You can read our helping guidelines.</p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mt-30">
                <div class="dashboard-shortcut kp-flat-card small-shadow p-0">
                  <a href="#" class="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                      <path
                        d="M40.7 10l1.4-8.9L24.1 0 24 0 5.8 1.1 7.3 10H0v1c0 12.6 10.1 22.8 22.6 23C21.4 37.3 17.5 46 10 46V48h28v-2c-7.5 0-11.4-8.7-12.6-12C37.9 33.8 48 23.6 48 11V10H40.7zM24 2l15.8 0.9L38 14.4C36.7 22.9 31.7 32 24 32c-7.6 0-12.5-8.9-14-17.6L8.2 2.9 24 2zM2 12h5.5L8 14.7c1 5.8 3.5 12.2 7.6 15.9C8 27.8 2.4 21 2 12zM31.6 46H16.4c3.9-3 6.3-7.2 7.6-10.1C25.2 38.8 27.6 43 31.6 46zM32.2 30.7c4.2-3.7 6.9-10 7.8-16L40.4 12h5.5C45.6 21 39.9 27.9 32.2 30.7z"
                      />
                    </svg>
                    <div>
                      <h5>Join our rewards program</h5>
                      <p class="mb-0">You'll get points for each action you take.</p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mt-30">
                <div class="dashboard-shortcut kp-flat-card small-shadow p-0">
                  <a href="#" class="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                      <path d="M7.6 1.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S10.9 1.6 7.6 1.6zM7.6 11.6c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4S9.8 11.6 7.6 11.6z" class="a" />
                      <path d="M7.6 17.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S10.9 17.6 7.6 17.6zM7.6 27.6c-2.2 0-4-1.8-4-4 0-2.2 1.8-4 4-4s4 1.8 4 4C11.6 25.8 9.8 27.6 7.6 27.6z" class="a" />
                      <path d="M23.6 1.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S26.9 1.6 23.6 1.6zM23.6 11.6c-2.2 0-4-1.8-4-4s1.8-4 4-4c2.2 0 4 1.8 4 4S25.8 11.6 23.6 11.6z" class="a" />
                      <path
                        d="M23.6 17.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S26.9 17.6 23.6 17.6zM23.6 27.6c-2.2 0-4-1.8-4-4 0-2.2 1.8-4 4-4 2.2 0 4 1.8 4 4C27.6 25.8 25.8 27.6 23.6 27.6z"
                        class="a"
                      />
                      <path d="M39.6 17.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S42.9 17.6 39.6 17.6zM39.6 27.6c-2.2 0-4-1.8-4-4 0-2.2 1.8-4 4-4s4 1.8 4 4C43.6 25.8 41.8 27.6 39.6 27.6z" class="a" />
                      <path d="M7.6 33.6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6S10.9 33.6 7.6 33.6zM7.6 43.6c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4S9.8 43.6 7.6 43.6z" class="a" />
                    </svg>
                    <div>
                      <h5>Adjust configuration</h5>
                      <p class="mb-0">Create your own service configuration.</p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mt-30">
                <div class="dashboard-shortcut kp-flat-card small-shadow p-0">
                  <a href="#" class="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                      <path
                        d="M38.5 14L28.8 0.1l-1.7 1L36.1 14H11.9l9-12.8L19.2 0 9.5 14H0v8h4.1l2.8 18.4C7.6 44.8 11.4 48 15.9 48h16.3c4.5 0 8.2-3.2 8.9-7.6L43.9 22H48v-8H38.5zM39.1 40.1C38.5 43.5 35.6 46 32.1 46H15.9c-3.5 0-6.4-2.5-6.9-5.9L6.2 22h35.7L39.1 40.1zM46 20H2v-4h44V20z"
                      />
                      <polygon points="23 39 25 39 25 34 30 34 30 32 25 32 25 27 23 27 23 32 18 32 18 34 23 34 " />
                    </svg>
                    <div>
                      <h5>Add another shop to account</h5>
                      <p class="mb-0">Create your shop and start selling.</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-30 d-md-none"></div>
            <today-facts></today-facts>
          </div>
        </div>
        <div class="row mb-30">
          <div class="col-xl-3 col-lg-5 d-flex flex-column mb-30">
            <income-outcome></income-outcome>
            <top-products class="flex-fill"></top-products>
          </div>
          <div class="col-xl-9 col-lg-7">
            <main-analytics></main-analytics>
          </div>
        </div>
        <dashboard-transactions></dashboard-transactions>
        <div class="pt-40">
          <p class="mb-0">© kopplr 2020</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import DashboardHeader from '@/components/dashboard/DashboardHeader.vue'
import DashboardSidebar from '@/components/dashboard/DashboardSidebar.vue'
import SidebarOverlay from '@/components/dashboard/SidebarOverlay.vue'
import TodayFacts from '@/components/dashboard/TodayFacts.vue'
import IncomeOutcome from '@/components/dashboard/IncomeOutcome.vue'
import MainAnalytics from '@/components/dashboard/MainAnalytics.vue'
import TopProducts from '@/components/dashboard/TopProducts.vue'
import DashboardTransactions from '@/components/dashboard/DashboardTransactions.vue'

export default {
  computed: {
    ...mapFields({
      user: 'user',
      sideOpen: 'ui.dashSideOpen',
      registrationComplete: 'registration.complete'
    })
  },
  components: {
    DashboardHeader,
    DashboardSidebar,
    SidebarOverlay,
    TodayFacts,
    IncomeOutcome,
    MainAnalytics,
    TopProducts,
    DashboardTransactions
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$store.state.registration.complete) {
        next()
      } else {
        next('/dashboard/register')
      }
    })
  }
}
</script>
